import React from "react";

const Approved = () => {
  return (
    <div className="sales-tool-root">
      <h1>Approved comp</h1>
    </div>
  );
};

export default Approved;